import { styled } from '@mui/system'

export const Root = styled('div')``
